var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chb-focus-lock"}},[_c('div',{style:(_vm.hidden),attrs:{"tabIndex":_vm.disabled ? -1 : 0}}),_c('div',{style:(_vm.hidden),attrs:{"tabIndex":_vm.disabled ? -1 : 1}}),_c('div',{attrs:{"data-lock":""},on:{"focusout":_vm.onBlur}},[_vm._t("default")],2),_c('div',{style:(_vm.hidden),attrs:{"tabIndex":_vm.disabled ? -1 : 0}})])
}
var staticRenderFns = []

export { render, staticRenderFns }